<template>
  <v-app id="inspire">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <notifications group="notifications" position="top right" />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'spacestudio',

  data() {
    return {
      alert: {
        style: 'info',
        show: false,
        message: ''
      }
    }
  },

  mounted() {
    this.$root.$on(
      'user-settings-data-loaded',
      this.userSettingsDataLoadedHandler
    )
    this.loadDefaultSettings().then(() => this.loadDarkModeFromLocalStorage())
    this.loadTheme()
  },

  beforeDestroy() {
    this.$root.$off(
      'user-settings-data-loaded',
      this.userSettingsDataLoadedHandler
    )
  },

  computed: {
    ...mapGetters({
      userSettings: 'userSettings',
      defaultUserSettings: 'defaultUserSettings',
      localDefaultUserSettings: 'localDefaultUserSettings'
    })
  },

  watch: {},
  created() {},
  updated() {},

  methods: {
    ...mapActions(['loadDefaultSettings']),
    userSettingsDataLoadedHandler() {
      this.updateDarkModeFromSettings()
    },

    loadTheme() {
      this.$vuetify.theme.themes.dark.primary = '#5757FF'
      this.$vuetify.theme.themes.light.primary = '#5757FF'
      this.$vuetify.theme.themes.dark.error = '#FF5A5A'
      this.$vuetify.theme.themes.light.error = '#FF5A5A'
      this.$vuetify.theme.themes.dark.info = '#5757FF'
      this.$vuetify.theme.themes.light.info = '#5757FF'
      this.$vuetify.theme.themes.dark.success = '#3BE287'
      this.$vuetify.theme.themes.light.success = '#3BE287'
      this.$vuetify.theme.themes.dark.warning = '#FF962E'
      this.$vuetify.theme.themes.light.warning = '#FF962E'
    },

    loadDarkModeFromLocalStorage() {
      if (localStorage.getItem('darkMode') === 'true') {
        this.$vuetify.theme.dark = true
      } else if (localStorage.getItem('darkMode') === 'false') {
        this.$vuetify.theme.dark = false
      } else {
        this.$vuetify.theme.dark =
          this.defaultUserSettings?.standardConfigurations?.['Dark mode'] ??
          this.localDefaultUserSettings?.standardConfigurations?.[
            'Dark mode'
          ] ??
          false
      }
    },
    convertStringToBoolean(string) {
      if (string === 'true') {
        return true
      }
      return false
    },

    updateDarkModeFromSettings() {
      const userSettingsDarkMode =
        this.userSettings?.standardConfigurations?.['Dark mode']
      const localStorageDarkMode = localStorage.getItem('darkMode')
      if (
        userSettingsDarkMode != null &&
        userSettingsDarkMode !== '' &&
        (localStorageDarkMode == null ||
          localStorageDarkMode === '' ||
          this.convertStringToBoolean(localStorageDarkMode) !==
            userSettingsDarkMode)
      ) {
        localStorage.setItem('darkMode', userSettingsDarkMode)
        this.$router.go()
      }
    }
  }
}
</script>

<style lang="scss">
.v-application {
  font-family: Arial, sans-serif !important;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}
.vue-treeselect.treeselect-dark .vue-treeselect__control {
  background: #343434;
}
.vue-treeselect.treeselect-dark .vue-treeselect__menu {
  background: #343434;
}
.vue-treeselect.treeselect-dark .vue-treeselect__option--highlight {
  background: #404040;
}
.vue-treeselect.treeselect-dark
  .vue-treeselect--single
  .vue-treeselect__option--selected {
  background-color: #343434;
}
.vue-treeselect.treeselect-dark .vue-treeselect__single-value {
  color: white;
}
.vue-treeselect.treeselect-dark .vue-treeselect__option--selected {
  background: #404040;
}
.v-application code {
  background: #2d2d2d;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: grey !important;
}
</style>
